export default {
  title: '营销数据',
  activityInfo: '活动信息',
  activityInfoPlaceholder: '请输入活动名称、ID',
  dateRange: '日期范围',
  startDate: '开始日期',
  endDate: '结束日期',
  // KPI 卡片
  totalScanCount: '扫码总个数',
  cumulativeScanCount: '累计扫码个数',
  scanUserCount: '扫码人数',
  activityUserCount: '参与活动人数',
  winUserCount: '中奖人数',
  yesterday: '昨日:',
  // 趋势图
  trendTitle: '扫码趋势',
  periodWeek: '本周',
  periodMonth: '本月',
  scanCount: '扫码个数',
  scanCountSeries: '扫码个数',
  scanUserCountSeries: '扫码人数',
  winCount: '中奖人数',
  // 排行榜
  rankTitle: '扫码产品排行榜（TOP10）',
  rankNo: '排名',
  productName: '产品',
  scanCountCol: '扫码个数',
};
